/**
 * Range guard, not a product rule. With `MAX_INTERVAL` it keeps every period the
 * overlap scan expands inside the `Date` range.
 *
 * Both the create form and the server bound the first due date by this, so they
 * must read the same number: a form that allowed a seed the server rejects fails
 * as a generic 400, and one that blocked a seed the server accepts is
 * unexplainable to the planner.
 */
export const MAX_SEED_YEARS_AHEAD = 10;
